__turbopack_context__.v({
  "chip": "Slider-module__icWiLW__chip",
  "disabledTrackArea": "Slider-module__icWiLW__disabledTrackArea",
  "fill": "Slider-module__icWiLW__fill",
  "output": "Slider-module__icWiLW__output",
  "outputDisplay": "Slider-module__icWiLW__outputDisplay",
  "slider": "Slider-module__icWiLW__slider",
  "thumb": "Slider-module__icWiLW__thumb",
  "track": "Slider-module__icWiLW__track",
  "trackContainer": "Slider-module__icWiLW__trackContainer",
  "trackWrapper": "Slider-module__icWiLW__trackWrapper",
});
